import clsx from "clsx";

import { APP_THEME_LABELS, APP_THEMES } from "~/contexts/AppTheme/appThemeConstants.ts";
import { useAppThemeStore } from "~/contexts/AppTheme/useAppThemeStore.ts";

/**
 * Switches the app theme from each screen, at the right edge. The user turns it on in the user details. The debug
 * views render their screens in iframes, which follow the top window, so the switcher shows in the top window only.
 */
export const AppThemeEdgeSwitcher = () => {
    const { theme, setTheme, showEdgeSwitcher } = useAppThemeStore();

    if (!showEdgeSwitcher || window.self !== window.top) return null;

    return (
        <div className="fixed top-1/2 right-0 z-[100] flex -translate-y-1/2 flex-col gap-y-1 rounded-l-lg bg-black/70 p-1 backdrop-blur">
            {APP_THEMES.map((item) => (
                <button
                    key={item}
                    type="button"
                    title={APP_THEME_LABELS[item]}
                    onClick={() => setTheme(item)}
                    className={clsx(
                        "size-7 rounded text-xs font-bold",
                        item === theme ? "bg-primary-500 text-white" : "text-gray-400",
                    )}
                >
                    {APP_THEME_LABELS[item][0]}
                </button>
            ))}
        </div>
    );
};
